import { render, staticRenderFns } from "./USDT-TRC20.vue?vue&type=template&id=0beccb83&scoped=true"
import script from "./USDT-TRC20.vue?vue&type=script&lang=js"
export * from "./USDT-TRC20.vue?vue&type=script&lang=js"
import style0 from "./USDT-TRC20.vue?vue&type=style&index=0&id=0beccb83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beccb83",
  null
  
)

export default component.exports